export enum BaseP2pMessageType {
  Sync = 'sync',
  Acknowledge = 'acknowledge',
}

export type SyncP2pMessage<P2pMessage = any> = {
  type: BaseP2pMessageType.Sync;
  payload: {
    id: string;
    message: P2pMessage;
  };
};

export type AcknowledgeP2pMessage = {
  type: BaseP2pMessageType.Acknowledge;
  payload: {
    id: string;
  };
};

export type SyncOrAcknowledgeP2pMessage<P2pMessage = any> =
  | SyncP2pMessage<P2pMessage>
  | AcknowledgeP2pMessage;

export type BaseP2pMessage<Messages = any> =
  | SyncP2pMessage<Messages>
  | AcknowledgeP2pMessage;

const ValidMessageTypes = [...Object.values(BaseP2pMessageType)];

export const isValidBaseP2pMessage = <Messages = any>(
  message: any,
): message is BaseP2pMessage<Messages> => {
  return (
    typeof message === 'object' &&
    message !== null &&
    'type' in message &&
    typeof message.type === 'string' &&
    ValidMessageTypes.includes(message.type as any)
  );
};

export const isValidSyncOrAcknowledgeP2pMessage = <Messages>(
  message: any,
): message is SyncOrAcknowledgeP2pMessage<Messages> => {
  return (
    isValidBaseP2pMessage(message) &&
    [BaseP2pMessageType.Sync, BaseP2pMessageType.Acknowledge].includes(message.type)
  );
};
